import { memo } from 'react';

import GoogleGeminiIconSVG from '@/assets/google-gemini-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const IGoogleGeminiIcon = (props: Omit<IconProps, 'SVGComponent'>) => (
  <Icon SVGComponent={GoogleGeminiIconSVG} {...props} />
);

export const GoogleGeminiIcon = memo(IGoogleGeminiIcon) as typeof IGoogleGeminiIcon;
